import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind 클래스 병합 — 조건부 클래스와 충돌 해결을 한 번에 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
